import { styled, css } from '@vebox/etui-system';
import { createElement, Fragment } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import { Spring } from 'react-spring/renderprops.cjs';

const _excluded = ["hasText", "size", "isRound", "theme"],
  _excluded2 = ["hasSiblings", "iconOnly"];
const getTransform = iconOnly => {
  return iconOnly ? 'translate(20%, 0)' : 'translate(50%, -50%)';
};
const BadgePointSup = styled(Div).attrs(_ref => {
  let {
      hasText,
      size,
      isRound,
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2(_objectSpread2({
    fontSize: size === 'sm' ? theme.typography.fontSizeSmall : theme.typography.fontSizeXSmall,
    bg: theme.palette.brand.light,
    color: theme.palette.common.white,
    borderRadius: `${theme.spacing.lg}px`
  }, isRound ? {
    width: size === 'sm' ? '14px' : '18px',
    height: size === 'sm' ? '14px' : '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  } : {
    pt: `${theme.spacing.xxs}px`,
    pb: `${theme.spacing.xxs}px`,
    pl: hasText ? `${theme.spacing.xs}px` : `${theme.spacing.xxs}px`,
    pr: hasText ? `${theme.spacing.xs}px` : `${theme.spacing.xxs}px`
  }), rest);
})`
  text-align: center;
  white-space: nowrap;
  line-height: 1;
  transition: 0.5s all cubic-bezier(0.7, 0.3, 0.3, 1.55);

  ${_ref2 => {
  let {
      hasSiblings,
      iconOnly
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return hasSiblings && css`
      position: absolute;
      top: ${rest.top || 0};
      right: 0;
      transform: ${getTransform(iconOnly)};
      transform-origin: center;
    `;
}};

  ${({
  animate,
  iconOnly
}) => animate && css`
      opacity: ${animate.opacity};
      transform: ${getTransform(iconOnly)} scale(${animate.scale});
    `};
`;

const Badge = ({
  styles = {},
  text,
  iconOnly,
  children,
  size = 'md',
  isRound,
  animationDisabled
}) => {
  function renderBadge() {
    if (children) {
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Div, {
        position: "relative"
      }, children), /*#__PURE__*/createElement(Spring, {
        from: {
          scale: 0,
          opacity: 0
        },
        to: {
          scale: 1,
          opacity: 1
        },
        config: {
          duration: 100
        }
      }, animate => /*#__PURE__*/createElement(BadgePointSup, _extends({
        hasText: !!text,
        hasSiblings: true,
        iconOnly: iconOnly,
        animate: !animationDisabled && animate,
        size: size,
        isRound: isRound
      }, styles.root), text)));
    }
    return /*#__PURE__*/createElement(BadgePointSup, _extends({
      hasText: !!text,
      size: size,
      isRound: isRound
    }, styles.root), text);
  }
  const badge = renderBadge();
  return /*#__PURE__*/createElement(Div, {
    display: "inline-block",
    position: "relative",
    testId: "badge"
  }, badge);
};

export default Badge;
